var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterNotApplied({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "4.04898689e-17 0 18.1169891 0 18.1169891 20 4.04898689e-17 20"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/System/Filter/NotApplied/20px",
    stroke: "none",
    strokeWidth: 1,
    fill: "#00A0AF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1, 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A0AF",
    d: "M10.0585891,10.88 L10.0585891,18.22 L8.05858907,18.72 L8.05858907,10.88 L7.05858907,9.48 L0.998589074,1 L17.1185891,1 L11.0585891,9.48 L10.0585891,10.88 Z M0.187589074,1.581 L7.05858907,11.2 L7.05858907,20 L11.0585891,19 L11.0585891,11.2 L17.9295891,1.581 C18.4015891,0.919 17.9285891,0 17.1155891,0 L1.00158907,0 C0.188589074,0 -0.284410926,0.919 0.187589074,1.581 L0.187589074,1.581 Z",
    id: "Fill-1",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterNotApplied);
export default __webpack_public_path__ + "static/media/Filter_NotApplied.916ce27e89ce6ec9597b9cd59a637144.svg";
export { ForwardRef as ReactComponent };